module.exports = __webpack_public_path__ + "static/media/ear_with_lines.d7f6e3ca.png";